import { useEffect, useState } from 'react';

/**
 * A person's photo, or their initials (Prototype v13: "HT") when there is no
 * photo or it doesn't load. A saved photo can stop loading — the old upload
 * storage was retired — and a broken image must never be what shows.
 */
export function AvatarImage({ url, initials }: { url?: string | null; initials: string }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  if (!url || failed) return <>{initials || '?'}</>;
  return <img src={url} alt="" onError={() => setFailed(true)} />;
}
